import {
  MediasoupSocketApi,
  MixerAddAudioData,
  MixerAddAudioFileData,
  MixerAddVideoData,
  MixerAddVideoFileData,
  MixerInput,
  MixerPipeInput,
  MixerPipeLiveData,
  MixerPipeRecordingData,
  MixerPipeRtmpData,
  MixerPipeStopInput,
  MixerRemoveData
} from "avcore";

export class MixerApi extends MediasoupSocketApi {
  constructor(url: string, worker: number, token: string) {
    super(url, worker, token);
  }

  override async mixerAdd(
    data: MixerAddAudioData | MixerAddVideoData
  ): Promise<void> {
    try {
      return await super.mixerAdd(data);
    } catch (error) {
      const error1 = this.buildErrorFromErrorId(error.errorId);

      throw new Error(
        `Error: ${error1.message}, data: ${JSON.stringify(data)})`
      );
    }
  }

  override async mixerAddFile(
    data: MixerAddVideoFileData | MixerAddAudioFileData
  ): Promise<void> {
    try {
      return await super.mixerAddFile(data);
    } catch (error) {
      const error1 = this.buildErrorFromErrorId(error.errorId);

      throw new Error(
        `Error: ${error1.message}, data: ${JSON.stringify(data)})`
      );
    }
  }

  override async mixerRemove(data: MixerRemoveData): Promise<void> {
    try {
      return await super.mixerRemove(data);
    } catch (error) {
      const error1 = this.buildErrorFromErrorId(error.errorId);

      throw new Error(
        `Error: ${error1.message}, data: ${JSON.stringify(data)})`
      );
    }
  }

  override async mixerClose(data: MixerInput): Promise<void> {
    try {
      return await super.mixerClose(data);
    } catch (error) {
      const error1 = this.buildErrorFromErrorId(error.errorId);

      throw new Error(
        `Error: ${error1.message}, data: ${JSON.stringify(data)})`
      );
    }
  }

  override async mixerPipeStart(
    data: MixerPipeLiveData | MixerPipeRecordingData | MixerPipeRtmpData
  ): Promise<MixerPipeInput> {
    try {
      return await super.mixerPipeStart(data);
    } catch (error) {
      const error1 = this.buildErrorFromErrorId(error.errorId);

      throw new Error(
        `Error: ${error1.message}, data: ${JSON.stringify(data)})`
      );
    }
  }

  override async mixerPipeStop(data: MixerPipeStopInput): Promise<void> {
    try {
      return await super.mixerPipeStop(data);
    } catch (error) {
      const error1 = this.buildErrorFromErrorId(error.errorId);

      throw new Error(
        `Error: ${error1.message}, data: ${JSON.stringify(data)})`
      );
    }
  }

  private buildErrorFromErrorId(errorId: number) {
    switch (errorId) {
      case 401:
        return new Error("Unauthorized");
      case 530:
        return new Error("Invalid transport");
      case 531:
        return new Error("Invalid producer");
      case 532:
        return new Error("Invalid consumer");
      case 533:
        return new Error("Invalid stream");
      case 534:
        return new Error("Invalid operation");
      case 535:
        return new Error("Invalid worker");
      case 536:
        return new Error("Invalid input");
      case 537:
        return new Error("Invalid action");
      default:
        return new Error(`Unknown error: ${errorId}`);
    }
  }
}
